export const pushToDataLayer = (event) => {
  window.dataLayer && window.dataLayer.push(event); // eslint-disable-line chai-friendly/no-unused-expressions
};

export const getProductFieldObject = (
  departureAirportCodeOrWvId,
  destinationAirportCodeOrWvId,
  hotelCode,
  price,
  hotelProductName,
  isCharter,
  position,
) => {
  return {
    name: `${departureAirportCodeOrWvId} - ${destinationAirportCodeOrWvId}`,
    id: hotelCode || '',
    price: price.toPay,
    brand: hotelProductName || '',
    category: isCharter ? 'CharterPackage' : 'IndependentPackage',
    list: 'Price Offer List',
    position,
  };
};

export const logProductClick = (product) => {
  pushToDataLayer({ ecommerce: null }); // Clear the previous ecommerce object as recommended by Google.
  pushToDataLayer({
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: 'Price Offer List',
          action: 'click',
        },
        products: [product],
      },
    },
  });
};
